module.exports = __webpack_public_path__ + "img/tuv.829fb9d8.svg";